var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-plotly"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.innerLoading || _vm.loading),expression:"innerLoading || loading"}],ref:"plotly",class:['plotly-plot', { 'hide-axistext': _vm.hideAxisText }]})])
}
var staticRenderFns = []

export { render, staticRenderFns }